import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.discounts.head'),
        url: RouteEntity.Root + RouteEntity.Discounts,
        objName: [PrivilegesModules.DiscCoupons],
    },
];

export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {
    programs: [
        {
            mdId: 1,
            mdName: 'global.labels.info',
            urlTemplate:
                RouteEntity.Root + RouteEntity.Discounts + '/#id#/' + RouteEntity.Info,
        },
        {
            mdId: 2,
            mdName: 'global.labels.coupons',
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Discounts +
                '/#id#/' +
                RouteEntity.Coupon,
        },
    ],
};
